import React from 'react';
import Header from '../components/Header';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';

function AntiRagging() {
  return (
    <div id="top">
      <div id="wrapper">
        <Header />
        <div id="navig_inside">
          <Navigation />
        </div>
        <div id="banner"></div>
        <div id="inside_page" className="bodyText">
          <div id="page1">
            <span className="bodyText">
              <p className="welcome_heading"><strong>ANTI RAGGING</strong></p>
              <div className="clear"></div>
            </span>
            <div id="facil">
              <div style={{ textAlign: 'left' }}></div>
              <p style={{ textAlign: 'center' }}><br />
                <br />
                <img src="/images/untitled.jpg" alt="" width="554" height="431" /><br />
                <br />
                <span style={{ color: '#993333', fontWeight: 'bold', fontSize: '10pt' }}>NATIONAL ANTI-RAGGING HELPLINE
                  :<br />
                  Phone No. : 1800-180-5522<br />
                  Email : helpline@antiragging.net
                </span></p>
              <p style={{ textAlign: 'center' }}><br />
                <strong className="Course2">ANTI – RAGGING COMMITTEE</strong><br />
              </p>
              <p style={{ textAlign: 'center' }}>As per the notification of AICTE, New Delhi, institutions of Technical Education all over the country are required to implement the measures under the Prevention and Prohibition of Ragging. Accordingly, we have formed an Anti-Ragging Committee, an Anti-Ragging Squad and other procedures are followed to fulfil the requirements.<br />
                <br />
                <strong style={{ color: '#993333', fontWeight: 'bold', fontSize: '10pt' }}>Ragging constitutes of the following Acts. </strong></p>
              <ul>
                <li>Any conduct by any student or students whether by words spoken or by written or by an act which as the effect of teasing, treating or handling with rudeness a fresher or any other student.</li>
                <li>Indulging in rowdy or in disciplined activities by any student or students which causes trouble or physical harm or psychological harm in any fresher or any other student.</li>
                <li>Any act by a senior student that prevents or disturbs the regular academic activity of a fresher.</li>
                <li>Any act of financial extortion of forceful expenditure burden put on a fresher or any student.</li>
                <li>Any act that effects the mental health and self-confidence of a fresher or any other student.</li>
              </ul>
              <p><strong style={{ color: '#993333', fontWeight: 'bold', fontSize: '10pt' }}>Administrative action in the event of Ragging </strong><br />
                <br />
                The Anti-Ragging committee of the institution shall take an appropriate decision in regard to punishment depending on the facts of each incident and nature of ragging established by the Anti-ragging squad, one or more of the following punishments, namely</p>
              <ul>
                <li>Suspension from attending classes</li>
                <li>With holding/withdrawing scholarships or other benefits</li>
                <li>Debarring from appearing in any test or examination.</li>
                <li>With holding results.</li>
                <li>Cancellation of admission.</li>
              </ul>
              <p style={{ color: '#993333', fontWeight: 'bold', fontSize: '10pt' }}>The list of Members of Anti- Ragging Committee constituted in the college is as below <strong>  </strong></p>
              <p>&nbsp;</p>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
}

export default AntiRagging;
